import styled from "styled-components"
import {
    color,
    layout,
    typography,
    flexbox,
    border,
    background,
    position,
    shadow,
    grid,
    space,
} from "styled-system"

const Label = styled.label`
    ${color}
    ${layout}
    ${typography}
    ${flexbox}
    ${border}
    ${background}
    ${position}
    ${shadow}
    ${grid}
    ${space}
    box-sizing: border-box;
`

export default Label
